module.exports = __webpack_public_path__ + "img/ENG.5729a786.svg";